import { usersApi } from '../api/usersApi'

export const completeSetup = async (token: string, password: string) => {
  try {
    const response = await usersApi.completeUserSetup(token, password)
    return response.data
  } catch (error) {
    console.error('Error completing user setup:', error)
    throw error
  }
}
